var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.supportTouchmove)?_c('div',{staticClass:"ucar-mask"},[_vm._t("default")],2):_c('div',{staticClass:"ucar-mask",on:{"touchmove":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }